var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutdoorTripHotelSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#575757",
    width: "64px",
    height: "64px",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "backpack"
  }), /*#__PURE__*/React.createElement("g", {
    id: "camping"
  }), /*#__PURE__*/React.createElement("g", {
    id: "transportation"
  }), /*#__PURE__*/React.createElement("g", {
    id: "navigation"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hotel"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M94,48v-4.3l0.7,0.2c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.4-0.1,0.6-0.2c0.3-0.2,0.4-0.5,0.4-0.8v-4c0-0.4-0.2-0.7-0.5-0.9 L74,26.4v-1.5l2.6,1c0.1,0,0.2,0.1,0.4,0.1c0.2,0,0.4-0.1,0.6-0.2c0.3-0.2,0.4-0.5,0.4-0.8v-4c0-0.4-0.2-0.7-0.5-0.9l-27-16 c-0.3-0.2-0.7-0.2-1,0l-27,16C22.2,20.3,22,20.6,22,21v4c0,0.3,0.2,0.6,0.4,0.8c0.3,0.2,0.6,0.2,0.9,0.1l2.6-1v1.5L4.5,38.1 C4.2,38.3,4,38.6,4,39v4c0,0.3,0.2,0.6,0.4,0.8C4.6,43.9,4.8,44,5,44c0.1,0,0.2,0,0.3-0.1L6,43.7V48v32v10H5c-0.6,0-1,0.4-1,1v4 c0,0.6,0.4,1,1,1h90c0.6,0,1-0.4,1-1v-4c0-0.6-0.4-1-1-1h-1V80V48z M82,79v-6h4v6H82z M92,49v6h-4v-6H92z M86,63h-4v-6h4V63z M88,57h4v6h-4V57z M82,65h4v6h-4V65z M88,65h4v6h-4V65z M86,55h-4v-6h4V55z M88,73h4v6h-4V73z M94,39.6v2l-20-7.3v-5.6L94,39.6z M24,21.6L50,6.2l26,15.4v2l-25.6-10c-0.1,0-0.2-0.1-0.4-0.1s-0.2,0-0.4,0.1L24,23.5V21.6z M50,15.5l22,8.6V35v55H60V67 c0-0.6-0.4-1-1-1H41c-0.6,0-1,0.4-1,1v23H28V35V24.1L50,15.5z M58,90H42V68h16V90z M6,39.6l20-10.9v5.6L6,41.6V39.6z M18,49v6h-4 v-6H18z M8,79v-6h4v6H8z M14,65h4v6h-4V65z M12,71H8v-6h4V71z M18,63h-4v-6h4V63z M12,63H8v-6h4V63z M14,73h4v6h-4V73z M12,55H8 v-6h4V55z M8,81h11c0.6,0,1-0.4,1-1V48c0-0.6-0.4-1-1-1H8v-4c0,0,0,0,0,0l18-6.5V90H8V81z M94,94H6v-2h1h20h14h18h14h20h1V94z M74,90V36.4L92,43c0,0,0,0,0,0v4H81c-0.6,0-1,0.4-1,1v32c0,0.6,0.4,1,1,1h11v9H74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,36h8c0.6,0,1-0.4,1-1v-8c0-0.6-0.4-1-1-1h-8c-0.6,0-1,0.4-1,1v8C31,35.6,31.4,36,32,36z M33,28h6v6h-6V28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,36h8c0.6,0,1-0.4,1-1v-8c0-0.6-0.4-1-1-1h-8c-0.6,0-1,0.4-1,1v8C45,35.6,45.4,36,46,36z M47,28h6v6h-6V28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,36h8c0.6,0,1-0.4,1-1v-8c0-0.6-0.4-1-1-1h-8c-0.6,0-1,0.4-1,1v8C59,35.6,59.4,36,60,36z M61,28h6v6h-6V28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,49h8c0.6,0,1-0.4,1-1v-8c0-0.6-0.4-1-1-1h-8c-0.6,0-1,0.4-1,1v8C31,48.6,31.4,49,32,49z M33,41h6v6h-6V41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,49h8c0.6,0,1-0.4,1-1v-8c0-0.6-0.4-1-1-1h-8c-0.6,0-1,0.4-1,1v8C45,48.6,45.4,49,46,49z M47,41h6v6h-6V41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,49h8c0.6,0,1-0.4,1-1v-8c0-0.6-0.4-1-1-1h-8c-0.6,0-1,0.4-1,1v8C59,48.6,59.4,49,60,49z M61,41h6v6h-6V41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,62h8c0.6,0,1-0.4,1-1v-8c0-0.6-0.4-1-1-1h-8c-0.6,0-1,0.4-1,1v8C31,61.6,31.4,62,32,62z M33,54h6v6h-6V54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,62h8c0.6,0,1-0.4,1-1v-8c0-0.6-0.4-1-1-1h-8c-0.6,0-1,0.4-1,1v8C45,61.6,45.4,62,46,62z M47,54h6v6h-6V54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,62h8c0.6,0,1-0.4,1-1v-8c0-0.6-0.4-1-1-1h-8c-0.6,0-1,0.4-1,1v8C59,61.6,59.4,62,60,62z M61,54h6v6h-6V54z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "money"
  }), /*#__PURE__*/React.createElement("g", {
    id: "signpost"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ticket"
  }), /*#__PURE__*/React.createElement("g", {
    id: "schedule"
  }), /*#__PURE__*/React.createElement("g", {
    id: "beach"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mountain"
  }), /*#__PURE__*/React.createElement("g", {
    id: "location"
  }), /*#__PURE__*/React.createElement("g", {
    id: "traveling"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bonfire"
  }), /*#__PURE__*/React.createElement("g", {
    id: "camera"
  }), /*#__PURE__*/React.createElement("g", {
    id: "medicine"
  }), /*#__PURE__*/React.createElement("g", {
    id: "drink"
  }), /*#__PURE__*/React.createElement("g", {
    id: "canned_food"
  }), /*#__PURE__*/React.createElement("g", {
    id: "nature"
  }), /*#__PURE__*/React.createElement("g", {
    id: "map"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdoorTripHotelSvgrepoCom);
export default __webpack_public_path__ + "static/media/outdoor-trip-hotel-svgrepo-com.fbffa062f22fa95bb650af9a17c776a2.svg";
export { ForwardRef as ReactComponent };